export const navSchema = [
  {
    title: 'Overview',
    alias: '',
    isPinned: true,
    isActive: true,
  },
  {
    title: 'About',
    alias: 'about',
    isPinned: false,
    isActive: false,
  },
  {
    title: 'Reviews',
    alias: 'reviews',
    isPinned: true,
    isActive: true,
  },
  {
    title: 'Portfolio',
    alias: 'portfolio',
    isPinned: false,
    isActive: false,
  },
  {
    title: 'Strategy',
    alias: 'strategy',
    isPinned: false,
    isActive: false,
  },
];
